import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=5547f467&scoped=true&"
import script from "./StepItem.vue?vue&type=script&lang=js&"
export * from "./StepItem.vue?vue&type=script&lang=js&"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=5547f467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547f467",
  null
  
)

export default component.exports